import { useEffect } from 'react';

import { getQueryParams } from "../../utils/utils";
import { getStorageItem, removeStorageItem } from '../../utils/local-storage';
import WaitingIndicator from '../general-ui/waiting-indicator/waiting-indicator';
import Alerts from '../general-ui/alert/alert';

const SSORedirect: React.FC = () => {

	const queryParams = getQueryParams(location.search);

	const authCode = queryParams?.code;
	const state = queryParams?.state;

	useEffect(() => {
		let ssoEventUrl = getStorageItem('sso_event_url');

		if (ssoEventUrl) {

			let code = authCode;

			if (state && state !== getStorageItem('sso_state')) { // Validate State
				console.warn('State is not correct');
				code = null;
			}

			removeStorageItem('sso_event_url'); // immediately remove so going to different events does not cause problems
			removeStorageItem(`sso_state`);

			try {
				ssoEventUrl = new URL(ssoEventUrl);
			} catch (e) {
				console.error(`Invalid sso_event_url: ${ssoEventUrl}`);
				code = null; // Don't try to forward to an invalid URL
			}

			// If no code, stay so the error can be captured while testing 
			if (code) {
				ssoEventUrl.searchParams.append('code', code);
				window.location.href = ssoEventUrl.href;
			}
		}
	}, [queryParams, authCode, state]);

	return (
		<div className='center-content-view-port'>
			<WaitingIndicator />
			<Alerts />
		</div>
	);
};

export default SSORedirect;
